import React from "react"

import ProductPage from "../../components/product_page"

const product = "interior-exterior-cladding"

const Page = () => <ProductPage product={product} />

export default Page
